import {useInstance} from "../../../lib/mate/mate-utils";
import {api} from "../../../lib/api";
import MiniProjectTile from "../../../components/MiniProjectTile";
import {SearchCategory} from "../search-types";
import {ProjectId} from "../../../cdx-models/Project";
import {Row} from "@cdx/ds";

const ProjectOpt = ({id}: {id: ProjectId}) => {
  const project = useInstance("project", id);
  if (!project) return "unknown project";
  return (
    <Row sp="8px" align="center">
      <MiniProjectTile project={project} size={16} />
      <div>{project.name}</div>
    </Row>
  );
};

const projectCategory: SearchCategory<ProjectId | null> = {
  key: "project",
  label: "Project",
  getSuggestions({input, projects}) {
    if (input.length < 2) return [];
    return [
      ...projects
        .filter((d) => d.$meta.get("name", "").toLowerCase().indexOf(input) > -1)
        .map((d) => d.id as ProjectId),
      ...("no decks".startsWith(input) ? [null] : []),
    ];
  },
  valueToKey(value) {
    return value;
  },
  valuesToDbQuery(values) {
    const nonNulls = values.filter((v) => v !== null);
    if (nonNulls.length !== values.length) {
      return {$or: [{deck: {projectId: nonNulls}}, {deckId: null}]};
    } else {
      return {deck: {projectId: nonNulls}};
    }
  },
  renderSuggestion(value) {
    return value ? <ProjectOpt id={value} /> : "No project";
  },
  savedSearchLabel(value) {
    if (!value)
      return {
        prio: -3,
        label: `w/o project`,
      };
    const project = api.getModel({modelName: "project", id: value});
    return {
      prio: -3,
      label: `in '${project?.name.slice(0, 16)}'`,
    };
  },
};

export default projectCategory;
